// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/back.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.love-list-page {
  min-height: 100vh;
  position: relative;
  z-index: 2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* 上半部分 - 透明区域 */
.lovelist-top-section {
  min-height: 40vh;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px 40px;
  position: relative;
}

.lovelist-top-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, 
    rgba(255, 182, 193, 0.6) 0%, 
    rgba(255, 192, 203, 0.5) 20%,
    rgba(255, 218, 224, 0.4) 50%,
    rgba(255, 240, 245, 0.3) 80%, 
    rgba(255, 255, 255, 0.2) 100%);
  z-index: 1;
}

.lovelist-top-section > * {
  position: relative;
  z-index: 2;
}

/* 波浪线分割 */
.lovelist-wave-divider {
  width: 100%;
  height: 180px;
  overflow: hidden;
  position: relative;
  z-index: 3;
  background: transparent;
  margin-top: -50px;
}

.lovelist-wave-divider svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 180px;
}

/* 下半部分 - 从下方粉色到中间白色渐变 */
.lovelist-bottom-section {
  min-height: 60vh;
  background: linear-gradient(to top, 
    rgba(255, 182, 193, 0.9) 0%, 
    rgba(255, 192, 203, 0.8) 20%, 
    rgba(255, 205, 215, 0.7) 45%, 
    rgba(255, 228, 235, 0.5) 75%, 
    rgba(255, 240, 245, 0.4) 100%
  );
  padding: 40px 20px;
  position: relative;
}

.love-list-container {
  max-width: 1000px;
  margin: 0 auto;
}

.love-list-header {
  text-align: center;
  margin-bottom: 40px;
}

.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.love-list-title {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.title-icon {
  color: #ff69b4;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
}

.love-list-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  margin-bottom: 30px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.progress-section {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
}

.progress-text {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.progress-bar {
  width: 100%;
  height: 10px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);
  border-radius: 5px;
  transition: width 1s ease;
}

.category-filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 30px;
}

.category-btn {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.category-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.category-btn.active {
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);
}

.love-list-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.love-list-item {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
  overflow: hidden;
}

.love-list-item.completed {
  background: rgba(34, 197, 94, 0.15);
  border-color: rgba(34, 197, 94, 0.3);
}

.love-list-item.completed::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(34, 197, 94, 0.1);
  pointer-events: none;
}

.love-list-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);
}

.item-emoji {
  font-size: 2.5rem;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
}

.item-content {
  flex: 1 1;
}

.item-task {
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.love-list-item.completed .item-task {
  text-decoration: line-through;
  opacity: 0.7;
}

.item-category {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.1);
  padding: 4px 10px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.item-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.check-btn,
.delete-btn {
  width: 35px;
  height: 35px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.check-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.check-btn.completed {
  background: linear-gradient(45deg, #22c55e, #16a34a);
  color: white;
  border-color: #22c55e;
}

.check-btn:hover {
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.3);
}

.delete-btn {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
  border: 2px solid rgba(239, 68, 68, 0.3);
}

.delete-btn:hover {
  transform: scale(1.1);
  background: rgba(239, 68, 68, 0.3);
  color: white;
}

.add-task-section {
  text-align: center;
}

.add-task-btn {
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  border: none;
  color: white;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 auto;
}

.add-task-btn:hover {
  background: linear-gradient(45deg, #ff1493, #dc143c);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 105, 180, 0.6);
}

.add-form {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 500px;
  margin: 0 auto;
}

.task-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 15px 20px;
  color: white;
  font-size: 16px;
  margin-bottom: 15px;
  transition: all 0.3s ease;
}

.task-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.task-input:focus {
  outline: none;
  border-color: #ff69b4;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 0 3px rgba(255, 105, 180, 0.2);
}

.category-select {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 15px 20px;
  color: white;
  font-size: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.category-select:focus {
  outline: none;
  border-color: #ff69b4;
  background: rgba(255, 255, 255, 0.2);
}

.category-select option {
  background: #333;
  color: white;
}

.form-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.confirm-btn,
.cancel-btn {
  padding: 12px 25px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.confirm-btn {
  background: linear-gradient(45deg, #22c55e, #16a34a);
  color: white;
  box-shadow: 0 4px 15px rgba(34, 197, 94, 0.3);
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.5);
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .love-list-grid {
    grid-template-columns: 1fr;
  }
  
  .love-list-title {
    font-size: 2rem;
  }
  
  .category-filter {
    gap: 8px;
  }
  
  .category-btn {
    padding: 8px 15px;
    font-size: 12px;
  }
  
  .love-list-item {
    padding: 20px;
  }
  
  .item-emoji {
    font-size: 2rem;
  }
  
  .item-task {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .love-list-page {
    padding: 10px;
  }
  
  .back-btn {
    position: relative;
    top: auto;
    left: auto;
    margin-bottom: 20px;
    display: inline-flex;
  }
  
  .love-list-title {
    font-size: 1.8rem;
  }
  
  .progress-section {
    padding: 15px;
  }
  
  .add-form {
    padding: 20px 15px;
  }
  
  .form-actions {
    flex-direction: column;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/LoveListPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;kCAKgC;EAChC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB;;;;;;GAMC;EACD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".love-list-page {\n  min-height: 100vh;\n  position: relative;\n  z-index: 2;\n  background-image: url('../assets/back.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n/* 上半部分 - 透明区域 */\n.lovelist-top-section {\n  min-height: 40vh;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px 40px;\n  position: relative;\n}\n\n.lovelist-top-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, \n    rgba(255, 182, 193, 0.6) 0%, \n    rgba(255, 192, 203, 0.5) 20%,\n    rgba(255, 218, 224, 0.4) 50%,\n    rgba(255, 240, 245, 0.3) 80%, \n    rgba(255, 255, 255, 0.2) 100%);\n  z-index: 1;\n}\n\n.lovelist-top-section > * {\n  position: relative;\n  z-index: 2;\n}\n\n/* 波浪线分割 */\n.lovelist-wave-divider {\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n  position: relative;\n  z-index: 3;\n  background: transparent;\n  margin-top: -50px;\n}\n\n.lovelist-wave-divider svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 180px;\n}\n\n/* 下半部分 - 从下方粉色到中间白色渐变 */\n.lovelist-bottom-section {\n  min-height: 60vh;\n  background: linear-gradient(to top, \n    rgba(255, 182, 193, 0.9) 0%, \n    rgba(255, 192, 203, 0.8) 20%, \n    rgba(255, 205, 215, 0.7) 45%, \n    rgba(255, 228, 235, 0.5) 75%, \n    rgba(255, 240, 245, 0.4) 100%\n  );\n  padding: 40px 20px;\n  position: relative;\n}\n\n.love-list-container {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.love-list-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.back-btn {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  color: white;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.back-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.love-list-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n\n.title-icon {\n  color: #ff69b4;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n}\n\n.love-list-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1.1rem;\n  margin-bottom: 30px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.progress-section {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin-bottom: 20px;\n}\n\n.progress-text {\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.progress-bar {\n  width: 100%;\n  height: 10px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);\n  border-radius: 5px;\n  transition: width 1s ease;\n}\n\n.category-filter {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.category-btn {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.category-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.category-btn.active {\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  border-color: rgba(255, 255, 255, 0.5);\n  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);\n}\n\n.love-list-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.love-list-item {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  position: relative;\n  overflow: hidden;\n}\n\n.love-list-item.completed {\n  background: rgba(34, 197, 94, 0.15);\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.love-list-item.completed::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(34, 197, 94, 0.1);\n  pointer-events: none;\n}\n\n.love-list-item:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);\n}\n\n.item-emoji {\n  font-size: 2.5rem;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-5px); }\n}\n\n.item-content {\n  flex: 1;\n}\n\n.item-task {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 8px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.love-list-item.completed .item-task {\n  text-decoration: line-through;\n  opacity: 0.7;\n}\n\n.item-category {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.8);\n  background: rgba(255, 255, 255, 0.1);\n  padding: 4px 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.item-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.check-btn,\n.delete-btn {\n  width: 35px;\n  height: 35px;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n\n.check-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.check-btn.completed {\n  background: linear-gradient(45deg, #22c55e, #16a34a);\n  color: white;\n  border-color: #22c55e;\n}\n\n.check-btn:hover {\n  transform: scale(1.1);\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.delete-btn {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n  border: 2px solid rgba(239, 68, 68, 0.3);\n}\n\n.delete-btn:hover {\n  transform: scale(1.1);\n  background: rgba(239, 68, 68, 0.3);\n  color: white;\n}\n\n.add-task-section {\n  text-align: center;\n}\n\n.add-task-btn {\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  border: none;\n  color: white;\n  padding: 15px 30px;\n  border-radius: 25px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 auto;\n}\n\n.add-task-btn:hover {\n  background: linear-gradient(45deg, #ff1493, #dc143c);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(255, 105, 180, 0.6);\n}\n\n.add-form {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.task-input {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 15px;\n  padding: 15px 20px;\n  color: white;\n  font-size: 16px;\n  margin-bottom: 15px;\n  transition: all 0.3s ease;\n}\n\n.task-input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.task-input:focus {\n  outline: none;\n  border-color: #ff69b4;\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 0 0 3px rgba(255, 105, 180, 0.2);\n}\n\n.category-select {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 15px;\n  padding: 15px 20px;\n  color: white;\n  font-size: 16px;\n  margin-bottom: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.category-select:focus {\n  outline: none;\n  border-color: #ff69b4;\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.category-select option {\n  background: #333;\n  color: white;\n}\n\n.form-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.confirm-btn,\n.cancel-btn {\n  padding: 12px 25px;\n  border: none;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.confirm-btn {\n  background: linear-gradient(45deg, #22c55e, #16a34a);\n  color: white;\n  box-shadow: 0 4px 15px rgba(34, 197, 94, 0.3);\n}\n\n.confirm-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.5);\n}\n\n.cancel-btn {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .love-list-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .love-list-title {\n    font-size: 2rem;\n  }\n  \n  .category-filter {\n    gap: 8px;\n  }\n  \n  .category-btn {\n    padding: 8px 15px;\n    font-size: 12px;\n  }\n  \n  .love-list-item {\n    padding: 20px;\n  }\n  \n  .item-emoji {\n    font-size: 2rem;\n  }\n  \n  .item-task {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .love-list-page {\n    padding: 10px;\n  }\n  \n  .back-btn {\n    position: relative;\n    top: auto;\n    left: auto;\n    margin-bottom: 20px;\n    display: inline-flex;\n  }\n  \n  .love-list-title {\n    font-size: 1.8rem;\n  }\n  \n  .progress-section {\n    padding: 15px;\n  }\n  \n  .add-form {\n    padding: 20px 15px;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
